import React from 'react';

// Clickable KPI tiles — clicking one toggles it as the active filter
export const PeopleKpiStrip = ({ items, active, onSelect, testIdPrefix = 'kpi' }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
    {items.map((k, i) => {
      const isActive = active === k.id;
      return (
        <button key={k.id} type="button" onClick={() => onSelect(isActive ? null : k.id)}
          data-testid={`${testIdPrefix}-${k.id}`} data-active={isActive}
          style={{ animationDelay: `${i * 50}ms`, borderColor: isActive ? `${k.hex}66` : undefined, boxShadow: isActive ? `0 0 28px -12px ${k.hex}` : undefined }}
          className="group text-left relative overflow-hidden rounded-2xl border border-white/[0.06] bg-white/[0.02] p-4 hover:border-white/[0.15] hover:-translate-y-0.5 transition-[transform,border-color,box-shadow] duration-300 animate-[jewelFadeUp_0.4s_ease-out_both]">
          <div className={`pointer-events-none absolute -top-8 -right-8 w-20 h-20 rounded-full blur-3xl transition-opacity ${isActive ? 'opacity-80' : 'opacity-30 group-hover:opacity-60'}`} style={{ background: k.hex }} />
          <div className="relative">
            <div className="flex items-center justify-between mb-2">
              <k.Icon className="w-4 h-4" style={{ color: k.hex }} />
              {isActive && <span className="text-[8px] tracking-[0.2em] uppercase font-semibold" style={{ color: k.hex }}>Filtering</span>}
            </div>
            <p className="text-3xl font-light text-white tabular-nums leading-none">{k.value}</p>
            <p className="text-[9px] tracking-[0.15em] uppercase text-white/45 mt-2">{k.label}</p>
            {k.sub && <p className="text-[10px] text-white/30 mt-0.5 truncate">{k.sub}</p>}
          </div>
        </button>
      );
    })}
  </div>
);
